import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import ManageQuestionPaperSection from "../components/questioners/manage_questin_papers/ManageQuestionPaperSection";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import moment from 'moment';

import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import { Container } from "react-bootstrap";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

const FETCH_EXAMS = gql`
  query($institution_id: Int!, $exam_paper_id: Int, $page: Int, $limit: Int) {
    manageQuestions(institution_id: $institution_id, exam_paper_id: $exam_paper_id, page: $page, limit: $limit) {
        totalCount
        papers {
            id
            name
            exam_type
            no_of_sets
            start_time
            end_time
            is_completed
            filename
            exam_name
            class
            class_id
            sub_exam_type
            section
            branch
            exam_mode
        }
    }
  }
`;
const FETCH_EXAMS_COUNTS = gql` 
query($institution_id: Int!,$exam_mode:Int) {
globals(institution_id: $institution_id,exam_mode: $exam_mode) {
    manageQuestionData{
        total
        ongoing
        completed
        future
    }
    b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
      }
      educationalClasses {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
      }
    }
}
`;

const DELETE_EXAM = gql`
  mutation(
    $exam_paper_id: ID
    ) {
        deleteExamPaper(
            exam_paper_id: $exam_paper_id
    )
  }
`;

class ManageOfflineQuestionPaper extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: 1,
            page: 1,
            limit: 10,
            isPageLoading: false
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };


    handleDelete = async (e, cell, row, rowIndex, formatExtraData) => {
        await this.props.handleDelete({
            variables: {
                exam_paper_id: rowIndex.id
            },
            update: (store, { data }) => {
                const data1 = store.readQuery({
                    query: FETCH_EXAMS,
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid")),
                        exam_paper_id: 0,
                        page: this.state.page,
                        limit: this.state.limit
                    }
                });

                const globals = store.readQuery({
                    query: FETCH_EXAMS_COUNTS,
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid")),
                        exam_mode: 1,
                    }
                });

                if (rowIndex.is_completed == "completed") {
                    globals.globals.manageQuestionData.total = parseInt(globals.globals.manageQuestionData.total) - 1;
                    globals.globals.manageQuestionData.completed = parseInt(globals.globals.manageQuestionData.completed) - 1;
                }
                else {
                    globals.globals.manageQuestionData.total = parseInt(globals.globals.manageQuestionData.total) - 1;
                    let now = moment().unix();
                    if (now < rowIndex.start_time && rowIndex.is_completed == "Not completed") {
                        globals.globals.manageQuestionData.future = parseInt(globals.globals.manageQuestionData.future) - 1;
                    }
                    else if (now > rowIndex.start_time && now <= rowIndex.end_time && rowIndex.is_completed == "Not completed") {
                        globals.globals.manageQuestionData.ongoing = parseInt(globals.globals.manageQuestionData.ongoing) - 1;
                    }
                }

                try {
                    store.writeQuery({
                        query: FETCH_EXAMS_COUNTS,
                        variables: {
                            institution_id: parseInt(Cookies.get("institutionid")),
                            exam_mode: 1
                        },
                        data: globals
                    });

                }
                catch (e) {
                    console.log("Exception", e);
                }

                if (data1 && data1.manageQuestions) {
                    data1.manageQuestions.papers = data1.manageQuestions.papers.filter(x => x.id != rowIndex.id);
                    data1.manageQuestions.totalCount = data1.manageQuestions.totalCount - 1;
                    try {
                        store.writeQuery({
                            query: FETCH_EXAMS,
                            variables: {
                                institution_id: parseInt(Cookies.get("institutionid")),
                                exam_paper_id: 0,
                                page: this.state.page,
                                limit: this.state.limit
                            },
                            data: data1
                        });

                    }
                    catch (e) {
                        console.log("Exception", e);
                    }
                }

                if (data.deleteExamPaper === true) {
                    this.setState({ status: 2 });
                    setTimeout(() => {
                        this.DeleteSetpageLoad();
                    }, 1000);
                }
            }
        });
    }

    handlePageChange = (page, sizePerPage) => {
        this.setState({ page, limit: sizePerPage, isPageLoading: true });
        this.props.getExams.refetch({
            page: page,
            limit: sizePerPage
        }).then(() => {
            this.setState({ isPageLoading: false });
        }).catch((e) => {
            console.log("Refetch Error:", e);
            this.setState({ isPageLoading: false });
        });
    }

    DeleteSetpageLoad = () => {
        this.setState({ status: 1 });
        window.location.reload(false);
    }

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        const getExams = this.props.getExams;
        const loading2 = getExams.loading;
        const error2 = getExams.error;

        //if (loading1) return null;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        const manageOfflineQuestions = getExams.manageQuestions?.papers?.filter((item) => item.exam_mode === 1) || [];
        

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    {(loading1 == true || loading2 == true) && !this.state.isPageLoading && (<PreloaderTwo />)}
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">

                        {
                            !loading1 && !loading2 && (
                                <div className="main-content">
                                    <Container fluid>
                                        <ManageQuestionPaperSection
                                            stateData={this.state}
                                            manageQuestions={manageOfflineQuestions}
                                            totalCount={getExams.manageQuestions?.totalCount || 0}
                                            page={this.state.page}
                                            limit={this.state.limit}
                                            isPageLoading={this.state.isPageLoading}
                                            onPageChange={this.handlePageChange}
                                            globals={globals.globals}
                                            handleDelete={this.handleDelete} />
                                    </Container>
                                </div>)}

                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}


export default withRouter(compose(
    graphql(FETCH_EXAMS_COUNTS,
        {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_mode: 1,
                }
                ,
                fetchPolicy: 'network-only'
            }), name: "globals"
        }), 
    graphql(FETCH_EXAMS,

        {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_paper_id: 0,
                    page: 1,
                    limit: 10
                }
                ,
                fetchPolicy: 'network-only'
            }), name: "getExams"
        }), graphql(DELETE_EXAM, { 
            name: "handleDelete"
        }))(ManageOfflineQuestionPaper));